import './fonts/fonts.css';
import './styles.css';
import { afterFirstPaint } from './after-paint.ts';
import { initDownload } from './download.ts';
import { initFilm } from './film.ts';
import { initReveal } from './reveal.ts';

// Render modes for the build's own captures: ?og (the share image) and ?poster (the hero's still frame).
const params = new URLSearchParams(location.search);
for (const mode of ['og', 'poster']) if (params.has(mode)) document.documentElement.classList.add(mode);

initDownload();
initFilm();
initReveal();

// The hero scene (three.js) loads after the first paint, when the main thread is idle.
const stage = document.querySelector<HTMLElement>('[data-hero-stage]');
if (stage) {
  const load = () =>
    void import('./hero/boot.ts')
      .then((m) => m.boot(stage, document.querySelector('[data-hero-labels]'), document.querySelector('[data-hero-status]')))
      .catch(() => {});
  afterFirstPaint(() => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 2000 });
    else setTimeout(load, 200);
  });
}
